import { LineChart as LChart } from "@mui/x-charts/LineChart";
import dayjs, { Dayjs } from "dayjs";
import { FormGetField, FormsGetResponse } from "../../models/Form";
import React from "react";
import { Box, FormControl, InputLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

interface Props<T extends FormsGetResponse> {
  items: T[];
  xAxisKey: string;
  valueKey: string;
}

const LineChart = <T extends FormsGetResponse>({
  items,
  xAxisKey,
  valueKey,
}: Props<T>) => {
  const currentYear = dayjs();
  const [selectedStartDate, setSelectedStartDate] = React.useState<Dayjs>(
    currentYear.subtract(1, "year")
  );
  const [selectedEndDate, setSelectedEndDate] =
    React.useState<Dayjs>(currentYear);

  const getValuesPerDay = (items: any[], valueKey: string) => {
    const values = new Map<string, { date: Dayjs; value: number }>();

    items.forEach((item) => {
      const value = item.values.find(
        (b: FormGetField) => b.fieldAlias === valueKey
      )?.value;
      const dateValue = item.values.find(
        (a: FormGetField) => a.fieldAlias === xAxisKey
      )?.value;
      if (value && dateValue) {
        const date = dayjs(dateValue).format("YYYY-MM-DD");
        values.set(date, {
          date: dayjs(dateValue),
          value: parseInt(value),
        });
      }
    });

    const valuesPerDay = Array.from(values.values())
      .filter(
        (entry) => dayjs(entry.date) >= selectedStartDate.subtract(1, "day")
      )
      .filter((entry) => dayjs(entry.date) <= selectedEndDate)
      .sort((a, b) => {
        const dateA = dayjs(a.date);
        const dateB = dayjs(b.date);
        return dateA.diff(dateB);
      });

    return valuesPerDay;
  };

  const valuesPerDay = getValuesPerDay(items, valueKey);

  return (
    <Box>
      <Box sx={{ display: "flex", marginTop: 2 }}>
        <Box>
          <InputLabel>Startdatum</InputLabel>
          <FormControl sx={{ margin: 2 }}>
            <DatePicker
              value={selectedStartDate}
              onChange={(date) => setSelectedStartDate(dayjs(date))}
              format="YYYY-MM-DD"
            />
          </FormControl>
        </Box>
        <Box>
          <InputLabel>Slutdatum</InputLabel>
          <FormControl sx={{ margin: 2 }}>
            <DatePicker
              value={selectedEndDate}
              onChange={(date) => setSelectedEndDate(dayjs(date))}
              format="YYYY-MM-DD"
            />
          </FormControl>
        </Box>
      </Box>
      <LChart
        series={[
          {
            data: valuesPerDay.map((v) => v.value),
          },
        ]}
        xAxis={[
          {
            scaleType: "point",
            data: valuesPerDay.map((v) => v.date.format("YYYY-MM-DD")),
          },
        ]}
        yAxis={[
          {
            min: 0,
            max: 100,
          },
        ]}
        grid={{ vertical: true, horizontal: true }}
        tooltip={{ trigger: "item" }}
        height={300}
      />
    </Box>
  );
};

export default LineChart;
